import React from 'react';

import styled from '@emotion/styled';

import { Button } from '@shared/components/bootstrap';

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const Value = styled.span`
  min-width: 28px;
  text-align: center;
`;

const StepButton = styled(Button)`
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  line-height: 1;
`;

export const QuantityStepper: React.FC<{
  value: number;
  min?: number;
  onChange(quantity: number): void;
}> = ({ value, min = 1, onChange }) => {
  const decrementable = value > min;

  return (
    <Container>
      <StepButton
        type="button"
        kind="default"
        disabled={!decrementable}
        aria-label="Decrease quantity"
        onClick={() => onChange(value - 1)}
      >
        −
      </StepButton>
      <Value>{value}</Value>
      <StepButton type="button" kind="default" aria-label="Increase quantity" onClick={() => onChange(value + 1)}>
        +
      </StepButton>
    </Container>
  );
};
